import React from "react";

const TrackSortingPopup = ({
  trackInteractivitySortingPopUp,
  sortOptions,
  toggleSortOrder,
  handlerModelCancelSorting,
  handlerModelOkSorting,
  selectedLanguage,
}) => {
  if (!trackInteractivitySortingPopUp) return null;

  return (
    <div className="modalCus" id="myModal">
      <div className="modal-dialog modal-dialog-centered modal-dialog-sorting">
        <div className="modal-content">
          <div className="d-flex justify-content-center flex-column mb-2 text-center">
            <div className="d-flex fa-2x border-bottom h5 p-2 manage-track-sort bg-lightblue manage-track-sort-header ">
              <div className="col-sm-7 col-md-7 col-lg-7 manage-sortby">
                {selectedLanguage.LstLanguageCodes.UI_SortBy}
              </div>
              <div className="col-sm-5 col-md-5 col-lg-5 manage-orderby">
                {selectedLanguage.LstLanguageCodes.UI_OrderBy}
              </div>
            </div>
            {sortOptions.map((option) => (
              <div
                id="sortOptionsDiv"
                className="d-flex p-2 manage-track-sort manage-track-sort-chailed"
                onClick={(e) => toggleSortOrder(e, option.value)}>
                <input
                  id="chkNopleakers"
                  name="PleakersGroup"
                  type="radio"
                  style={{ marginRight: "2%" }}
                  checked={option.active == "false" ? false : true}
                />
                <div className="col-sm-7 col-md-7 col-lg-7" id="sortOptionsDivLabel">
                  {option.label}
                </div>
                <div
                  id="sortOptionsDivImg"
                  className={
                    option.active == "false"
                      ? "col-sm-5 col-md-5 col-lg-5 manage-orderby manage-track-sort-chailed-order"
                      : (option.order == "desc"
                        ? "col-sm-5 col-md-5 col-lg-5 manage-orderby manage-track-sort-chailed-order manage-track-sort-chailed-order-active" : "col-sm-5 col-md-5 col-lg-5 manage-orderby manage-track-sort-chailed-order manage-track-sort-chailed-order-active-up")
                  }>
                  <img
                    id="sortOptionsImg"
                    className={
                      option.order == "desc"
                        ? "manage-track-sort-chailed-up"
                        : "manage-track-sort-chailed-up"
                    }
                    src={
                      option.order == "desc"
                        ? "assets/img/icons/arrow-down.png"
                        : "assets/img/icons/arrow-up.png"
                    }
                    style={{ marginLeft: "84% !important" }}
                    alt="sort"
                  />
                  {option.order == "desc"
                    ? selectedLanguage.LstLanguageCodes.UI_HighToLow
                    : selectedLanguage.LstLanguageCodes.UI_LowToHigh}
                </div>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-end mb-2 mr-20">
            <button
              type="button"
              className="btn btn-danger modal-dialog-button"
              data-bs-dismiss="modal"
              onClick={(e) => handlerModelCancelSorting()}>
              {selectedLanguage.LstLanguageCodes.UI_Cancel}
            </button>
            <button
              type="button"
              className="btn btn-primary px-3 ms-3 modal-dialog-button"
              data-bs-dismiss="modal"
              onClick={(e) => handlerModelOkSorting()}>
              {selectedLanguage.LstLanguageCodes.UI_Apply}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackSortingPopup;
